import React, { useState } from 'react';
import { BeheerLayout } from '../../components/beheer/BeheerLayout';
import { BeheerSection } from '../../components/beheer/BeheerSection';
import { RoomTile } from '../../components/beheer/huis/RoomTile';
import { CameraTile } from '../../components/beheer/huis/CameraTile';
import { EnergyPanel } from '../../components/beheer/huis/EnergyPanel';
import { SecurityStatus } from '../../components/beheer/huis/SecurityStatus';
import { energy, outdoorCameras, roomExtras, ups } from '../../data/beheer/house';
import { useDb } from '../../hooks/useDb';
import { db } from '../../utils/db';
import { co2Band } from '../../utils/home';
export function Huis() {
  const rooms = useDb(t => t.rooms);
  const security = useDb(t => t.devices.filter(d => d.kind === 'slot' || d.kind === 'alarm' || d.kind === 'watersensor'));
  const [scenes, setScenes] = useState<Record<string, string | null>>(() => Object.fromEntries(roomExtras.map(r => [r.roomId, r.activeScene])));
  const occupied = rooms.filter(r => r.presence !== 'leeg').length;
  const ventilate = rooms.filter(r => co2Band(r.co2) !== 'goed');
  const pickScene = (roomId: string, name: string, scene: string | null) => {
    setScenes(s => ({
      ...s,
      [roomId]: scene
    }));
    db.log({
      agent: 'huis',
      summary: scene ? `Scène "${scene}" in ${name.toLowerCase()} via beheer` : `Scène in ${name.toLowerCase()} uit via beheer`,
      level: 'zelf',
      where: 'lokaal',
      outcome: 'uitgevoerd'
    });
  };
  return <BeheerLayout title="Huis" intro="Kamers, klimaat, licht en camera’s zoals Anna ze ziet. Wat je hier aanpast, komt in het logboek." aside={<p className="text-[14px] text-ink-soft" data-id="element-1874" data-mp="2byoekfymz63n">
          {occupied} {occupied === 1 ? 'kamer' : 'kamers'} bezet
          {ventilate.length > 0 && <span className="text-amber" data-id="element-1875" data-mp="2pz8xdc4jx1x5"> · ventileer {ventilate.map(r => r.name.toLowerCase()).join(', ')}</span>}
        </p>} data-id="element-1873" data-mp="228lp2pqq4aa2">
      <BeheerSection id="kamers" title="Kamers" description="Aanwezigheid via mmWave, klimaat, licht en spraaksatelliet per kamer." className="mt-10" data-id="element-1876" data-mp="1in01jluq1502">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1877" data-mp="1njgrmllhdtfs">
          {rooms.map(room => <RoomTile key={room.id} room={room} extra={roomExtras.find(r => r.roomId === room.id)} scene={scenes[room.id] ?? null} onScene={s => pickScene(room.id, room.name, s)} data-id="element-1878" data-mp="1rl2260ajlvmt" />)}
        </div>
      </BeheerSection>

      <BeheerSection id="cameras" title="Buitencamera’s" description="Gemaskeerde delen worden nooit opgenomen of geanalyseerd. Beelden blijven op je eigen server." className="mt-16" data-id="element-1879" data-mp="2bb5q6jowbe56">
        <div className="grid gap-6 md:grid-cols-3" data-id="element-1880" data-mp="gxmk2lgsun89">
          {outdoorCameras.map(c => <CameraTile key={c.id} camera={c} data-id="element-1881" data-mp="ky6hlq5absux" />)}
        </div>
      </BeheerSection>

      <div className="mt-16 grid gap-10 xl:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]" data-id="element-1882" data-mp="dexa62gca48i">
        <BeheerSection id="energie" title="Energie en UPS" description="Slimme meter en zonnepanelen, plus de noodstroom voor de serverkast." data-id="element-1883" data-mp="8oguebp1q6iz">
          <EnergyPanel energy={energy} ups={ups} data-id="element-1884" data-mp="3qf9dl827x4v" />
        </BeheerSection>
        <BeheerSection id="beveiliging" title="Sloten en alarm" description="Alleen status. Bedienen doe je zelf." data-id="element-1885" data-mp="3vtpzq0zcldd3">
          <SecurityStatus devices={security} data-id="element-1886" data-mp="wd02or83ijb2" />
        </BeheerSection>
      </div>
    </BeheerLayout>;
}